import React from "react";
import { useForm } from "react-hook-form";
import { Header, Segment, Label, Form, Modal } from "semantic-ui-react";
import { ControlledInput } from "../../../../components/ControlledForm";

export const InspectionModal = (props: any) => {
  const { open, onClose, checklist, onFail, onPass, openModal } = props;
  const {
    control,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();
  const message = watch("message");
  function existsInArray(array: any, objKey: any, value: any): boolean {
    return array.some((outerArrayElement: any) => {
      return outerArrayElement.data.attributes.items.some((innerArrayElement: any) => {
        return innerArrayElement?.data.attributes[objKey] === value;
      });
    });
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      as={Form}
      closeIcon
      header={"Complete Inspection"}
      scrolling='true'
      size='small'
      content={
        <>
          <Segment basic className='failed-items'>
            <label style={{ fontSize: 13 }} className='bold' htmlFor='failed-items'>
              {" "}
              Failed Items{" "}
            </label>
            {checklist?.length > 0 && !existsInArray(checklist, "status", "failed") && (
              <p id='failed-items' style={{ marginTop: 4 }}>
                {" "}
                None{" "}
              </p>
            )}
            {checklist &&
              checklist.map((section: any) => {
                return section.data.attributes.items.map((item: any) => {
                  if (item.data.attributes.status == "failed") {
                    return (
                      <Segment>
                        <Header as='h4' className='unBold'>
                          {item.data.attributes.title}
                        </Header>
                      </Segment>
                    );
                  }
                });
              })}
          </Segment>
          <Segment basic className='summary-field'>
            <Form.Field required error={errors.message && { content: "You must enter a message", pointing: "above" }}>
              <ControlledInput
                control={control}
                label='Inspection Summary'
                defaultValue=''
                placeholder='Add any final details to send to the inspectee.'
                name={"message"}
              />
              {errors.message && (
                <Label basic prompt pointing='above'>
                  {"The inspection summary is required"}
                </Label>
              )}
            </Form.Field>
          </Segment>
        </>
      }
      actions={[
        {
          key: "fail",
          negative: true,
          content: "Submit and Fail",
          onClick: handleSubmit((data) => {
            if (message) {
              onFail(data.message);
            } else {
              openModal(true);
              setError("message", {});
            }
          }),
        },
        {
          key: "pass",
          positive: true,
          content: "Submit and Pass",
          onClick: handleSubmit((data) => {
            if (message) {
              onPass(data.message);
            } else {
              openModal(true);
              setError("message", {});
            }
          }),
        },
      ]}
    />
  );
};
